import {blue, grey} from "@mui/material/colors";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import React from "react";

export function KeyingCheckbox(props: {
    selected: boolean;
    onChange(value: boolean): void;
}) {
	return (
        <div
            style={{
                width: "100%", display: "flex", justifyContent: "center",
                fontSize: "0.9rem", cursor: "pointer",
                color: props.selected ? blue["600"] : grey["300"],
                borderRadius: 5,
                position: "relative",
            }}
        >
            {/* This div is used to capture mouse events */}
            <div
                style={{
                    position: "absolute",
                    top: 0, left: 0, right: 0, bottom: 0,
                }}
                onClick={() => {
                    props.onChange(!props.selected)
                }}
            ></div>
            {props.selected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
        </div>
    )
}